export default __webpack_public_path__ + "static/img_interviewee_dssong-bdfd2ea44a1a854b1f4256570e07c7e9.png";